/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Patchy_Heroic_Stork_BloomInputs */

const fr_patchy_heroic_stork_bloom = /** @type {(inputs: Patchy_Heroic_Stork_BloomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours du jour`)
};

/**

* @param {Patchy_Heroic_Stork_BloomInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const patchy_heroic_stork_bloom = /** @type {((inputs?: Patchy_Heroic_Stork_BloomInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Patchy_Heroic_Stork_BloomInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_patchy_heroic_stork_bloom(inputs)
});